var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('test',{attrs:{"o_Fields":_vm.o_Fields,"i_TestID":_vm.i_TestID,"i_LangID":_vm.i_LangID,"i_Translation":_vm.i_Translation,"i_TestTypeID":_vm.i_TestTypeID,"s_Number":_vm.s_Number}})}
var staticRenderFns = []

export { render, staticRenderFns }